// Country flags are served from public/images/flags — the same URLs the Vue 3
// tree uses. Inlining them here put 3 MB of raw SVG into the bundle.
const inlineModules = import.meta.glob(
  ['/resources/assets/images/inline/**/*', '!/resources/assets/images/inline/flags/**'],
  { eager: true, query: '?raw', import: 'default' },
)

const allFiles = Object.entries(inlineModules).reduce((o, [path, content]) => {
  const key = './' + path.replace(/^.*\/resources\/assets\/images\/inline\//, '')
  o[key] = content
  return o
}, {})

export default {
  namespaced: true,
  state: {
    imagesContent: allFiles,
  },
  getters: {
    _getSvg: (state) => (path) => state.imagesContent[path],
    _getSvgInBase64: (state) => (path) =>
      state.imagesContent[path] ? 'data:image/svg+xml;base64,' + window.btoa(state.imagesContent[path]) : null,
    _getFlagUrlById: () => (id) => (id ? '/images/flags/' + (id + '').toLowerCase() + '.svg' : null),
  },
  actions: {},
  mutations: {},
}
